// Inspired by react-hot-toast library
import { toast as sonnerToast } from "sonner";

function toast(props) {
  const { title, description, variant, ...rest } = props;

  // Map variants to Sonner functions
  if (variant === "destructive") {
    return sonnerToast.error(title, {
      description: description,
      ...rest,
    });
  }

  if (variant === "success") {
    return sonnerToast.success(title, {
      description: description,
      ...rest,
    });
  }

  // Default toast
  return sonnerToast(title, {
    description: description,
    ...rest,
  });
}

function useToast() {
  return {
    toast,
    dismiss: (toastId) => sonnerToast.dismiss(toastId),
    toasts: [],
  };
}

export { useToast, toast };
